import React, { useEffect, useState } from 'react';
import Hr from '../Elements/Hr';
import { SearchOutlined } from '@ant-design/icons';
import Hits from '@/components/Search/Hits';
import { searchStrapi } from '@/services/strapiService';
import { T, useTranslate } from '@tolgee/react';
import { useSelectedLanguage } from '@/redux/selectors/languageSelector';
import { SearchHit } from '@/types/search';
const CustomSearchBox = () => {
  const [query, setQuery] = useState('');
  const [hits, setHits] = useState<SearchHit[]>([]);
  const [isFetching, setIsFetching] = useState(false);
  const locale = useSelectedLanguage();
  const {
    t
  } = useTranslate();
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(event.currentTarget.value);
  };
  useEffect(() => {
    const MIN_QUERY_LENGTH = 3;
    const DEBOUNCE_INTERVAL = 800;
    const fetchExperts = async () => {
      if (query.length >= MIN_QUERY_LENGTH) {
        setIsFetching(true);
        try {
          setHits(await searchStrapi(query as string, locale));
        } catch (error) {
          console.error('Error fetching users:', error);
        } finally {
          setIsFetching(false);
        }
      } else {
        setHits([]);
      }
    };
    const delayDebounceFn = setTimeout(() => {
      fetchExperts();
    }, DEBOUNCE_INTERVAL);
    return () => clearTimeout(delayDebounceFn);
  }, [query]);
  return <>
      <div className="relative">
        <SearchOutlined className="absolute left-2 top-[12px] text-lg" data-sentry-element="SearchOutlined" data-sentry-source-file="SearchBox.tsx" />
        <input type="text" value={query} onChange={handleChange} placeholder={t('search.input.placeholder')} className="w-full p-2 pl-10 outline-none text-base" autoFocus={true} />
        <Hr className="mb-0" data-sentry-element="Hr" data-sentry-source-file="SearchBox.tsx" />
      </div>
      <div className="custom-modal-search-result-height">
        {isFetching ? <p className="text-center">
            <T>search.fetching_results.label</T>
          </p> : hits.length > 0 ? <Hits items={hits} /> : <p className="text-center">
            <T>search.no_results.label</T>
          </p>}
      </div>
    </>;
};
export default CustomSearchBox;